import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { agentActions } from '@src/store/reducers/agentReducer';

export const createAgentMiddleware = (http: any, successPopUp: any, errorPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [agentActions.GET_CLUSTER_WITH_AGENT]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Agent/GetClustersWithAgents`);
                const data = response.data;
                next({ type: action.type, payload: data });
                return data;
            } catch {
                errorPopUp();
            }
        },
        [agentActions.GET_AGENTS]: async (_: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Agent/GetAgents`);
                const data = response.data;
                next({ type: agentActions.GET_AGENTS, payload: data });
                return data;
            } catch {
                errorPopUp();
            }
        },
        [agentActions.UPDATE_AGENT]: async (action: any) => {
            try {
                const response = await http.post(`${restServiceUrl}Agent/UpdateAgent`, action.payload.agent);
                return response.data;
            } catch {
            }
        },
        [agentActions.UPDATE_CLUSTER]: async (action: any) => {
            try {
                const response = await http.post(`${restServiceUrl}Agent/UpdateCluster`, action.payload.cluster);
                const data = response.data;

                if (!data) {
                    errorPopUp();
                } else {
                    successPopUp();
                }
                return data;
            } catch {
            }
        },
        [agentActions.ADD_CLUSTER]: async (action: any) => {
            const response = await http.post(`${restServiceUrl}Agent/AddCluster`, action.payload.cluster);
            const data = response.data;
            if (!data) {
                errorPopUp();
            } else {
                successPopUp();
            }
            return data;
        },
        [agentActions.RESTART_AGENT]: async (action: any) => {
            const response = await http.get(`${restServiceUrl}Agent/${action.payload.agentId}/Restart/${action.payload.waitForJobs}`);
            return response.data;
        },
        [agentActions.DELETE_CLUSTER]: async (action: any) => {
            const response = await http.delete(`${restServiceUrl}Agent/DeleteCluster/${action.payload.clusterId}`);
            const data = response.data;
            if (!data) {
                errorPopUp();
            } else {
                successPopUp();
            }
            return data;
        },
        [agentActions.CHECK_VAULT_IN_CLUSTER]: async (action: any) => {
            const response = await http.get(`${restServiceUrl}Agent/CheckVaultInCluster`, action.payload.vault);
            return response.data;
        },
        [agentActions.GET_AGENT_JOBS_EXECUTING]: async (action: any) => {
            const response = await http.get(`${restServiceUrl}Agent/${action.payload.agentId}/GetJobsExecuting`);
            return response.data;
        },
        [agentActions.GET_AGENT_STATUS]: async (action: any) => {
            const response = await http.get(`${restServiceUrl}Agent/${action.payload.agentId}/GetStatus`);
            return response.data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/agent.middleware.ts